import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Empty, Select, message } from 'antd';
import { createUseStyles } from 'react-jss'

import { CollectionServer, Model, QueryDetail, QueryOrder, updateInArray, ObjectToQueryParam, POSTFormData, IfElse, deleteInArray, GET, QueryParam } from 'fennec-ui'
import { errorCatch } from 'fennec-ui'
import "./index.css"
import YImage from '../../../common/YImage';
import SeriiMeropriyatiya from '../../forms/SeriiMeropriyatiya';
import Kvoti from '../../forms/Kvoti';
import GorodaSerii from '../../forms/GorodaSerii';
import confirmKey from '../ConfirmKeyModal';
import Icofont from 'react-icofont';
import TantsiSerii from '../../forms/TantsiSerii';
import KategoriiUchastnikovSerii from '../../forms/KategoriiUchastnikovSerii';
import ParentEventSerii from '../../forms/ParentEventSerii';
import uuid from 'react-uuid';
import SeriiDiplomas from '../../forms/SeriiDiplomas';
import PromResultSeriiVK from '../../forms/PromResultSeriiVK';
import ItogResultSeriiVK from '../../forms/ItogResultSeriiVK';

const { Option } = Select;

const useStyles = createUseStyles({
    button: {
        marginLeft: "10px"
    }
})

export default function SeriiBlock(props) {
    const dispatch = useDispatch();
    const classes = useStyles();
    const { auth, source, create, strickted, ctx, base, sourceKey } = props;
    const [loading, setLoading] = useState(false);

    const filters = () => [
        {
            label: "Сезон",
            name: "sezon.nazvanie",
            display: (item) => {
                return item.nazvanie
            },
            sort: true,
            // sorted: "ASC",
            sorted: "DESC",
        },
        {
            label: "Сезон",
            name: "sezon",
            filterType: "group",
            display: (item) => {
                return item.nazvanie
            },
            queryFilter: [
                QueryDetail("model"),
                QueryOrder("prioritet", "ASC")
            ],
            filter: true,
            // filtered: [3],
        },
        {
            label: "Уровень серии",
            name: "urovenSerii",
            filterType: "group",
            display: (item) => {
                return item.opisanie
            },
            queryFilter: [
                QueryDetail("model"),
                QueryOrder("ID", "ASC")
            ],
            sort: true,
            filter: true,
        },
        {
            label: "Направления танцев",
            name: "tantsiSeriiSeriya.tanets",
            type: "object",
            filterType: "group",
            display: (item) => {
                return item.nazvanie
            },
            sort: false,
            filter: true,
            source: "/api/query/tantsi?detail=model&s-nazvanie=ASC",
        }
    ];

    const FilterFromContextFilter = React.useCallback(() => [
        ...ObjectToQueryParam((ctx) ? ctx : {})
    ], [ctx]);

    return (
        <div style={{ padding: "5px 10px", backgroundColor: "white", borderRadius: "4px" }}>
            {!ctx && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Нет данных" style={{ padding: "15px 0px" }} />}
            {ctx &&
            <CollectionServer
                name={"Serii"}
                auth={auth}
                size="small"
                source={source}
                contextFilters={FilterFromContextFilter}
                filters={filters}
                mode={"list"}
                render={(item, idx, { setCollection, setCollectionItem, update }) => {
                    return (<div key={idx} style={{ width: "100%" }} className="serii">
                        <div style={{ display: "flex", gap: "10px" }}>
                            <div style={{ flex: "78px" }}>
                                <div style={{ width: "78px", height: "78px", overflow: "hidden" }}>
                                    <YImage image={item.afisha} minimage={item.afishaMin} width={78} hidePreview={true} />
                                </div>
                            </div>
                            <div style={{ flex: "auto", width: "100%", fontSize: "13px" }}>
                                <div style={{ fontWeight: "300", fontSize: "12px", fontStyle: "italic" }}>
                                    <span style={{ fontWeight: "600", fontSize: "13px" }}>
                                        {item.nazvanie}
                                    </span>
                                </div>
                                <div>Сезон: {item?.sezon?.nazvanie}</div>
                                <div>Количество этапов: {item?.kolichestvoEtapov}</div>
                                <div>Уровень: {item?.urovenSerii?.opisanie}</div>
                                {(item?.tantsiSeriiSeriya?.length > 0) && <div>Направления танцев:
                                    {item?.tantsiSeriiSeriya?.map((el, idx) => {
                                        return (<span key={idx}> {el?.tanets?.nazvanie}{(idx != (item.tantsiSeriiSeriya.length - 1)) ? "," : ""}</span>)
                                    })}
                                </div>}
                                {/* <div style={{ fontWeight: "300" }}>
                                    {item.opisanie}
                                </div> */}
                            </div>
                            <div style={{ flex: "25px" }}>
                                <div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "500", fontSize: "13px" }}>

                                </div>
                            </div>
                        </div>
                    </div>)
                }}
                collectionActions={() => [
                    ...IfElse(
                        (create == true), [
                        {
                            isFormData: true,
                            modify: (values) => {
                                return { ...values, ...((ctx) ? ctx : {}) }
                            },
                            action: (values, unlock, close, { collection, setCollection }) => {
                                POSTFormData(auth, `/api/serii/new`, values,
                                    ({ data }) => {
                                        setCollection(updateInArray(collection, data));
                                        close();
                                    },
                                    (err) => errorCatch(err, unlock));
                            },
                            form: Model,
                            meta: [
                                {
                                    label: "Опубликовано",
                                    name: "isPublic",
                                    type: "bool",
                                },
                                {
                                    label: "Название",
                                    name: "nazvanie",
                                    type: "string",
                                },
                                {
                                    label: "Сезон",
                                    name: "sezon",
                                    type: "object",
                                    relation: {
                                        display: (item) => {
                                            return item.nazvanie
                                        },
                                        reference: { object: "Sezoni", property: "ID" },
                                        type: "many-one",
                                    },
                                    queryFilter: [
                                        QueryDetail("model"),
                                        QueryOrder("prioritet", "ASC")
                                    ]
                                },
                                {
                                    label: "Уровень серии",
                                    name: "urovenSerii",
                                    type: "object",
                                    relation: {
                                        display: (item) => {
                                            return item.opisanie
                                        },
                                        reference: { object: "UrovenSerii", property: "ID" },
                                        type: "many-one",
                                    },
                                    queryFilter: [
                                        QueryParam("w-eqi-UrovenSeriiVidOrgUroven.Organizator.Code", sourceKey),
                                        QueryDetail("model"),
                                        QueryOrder("ID", "ASC")
                                    ]
                                },
                                {
                                    label: "Количество этапов",
                                    name: "kolichestvoEtapov",
                                    type: "int",
                                },
                                {
                                    label: "Ссылка на серию в ВК",
                                    name: "vk",
                                    type: "string",
                                },
                                {
                                    label: "Описание",
                                    name: "opisanie",
                                    type: "text",
                                },
                                {
                                    label: "Описание для ВК",
                                    name: "opisanieDlyaVK",
                                    type: "text",
                                },
                                {
                                    label: "Афиша",
                                    name: "file",
                                    type: "file",
                                }
                            ],
                            options: {
                                initialValues: {},
                            },
                            title: "Добавить серию",
                            modal: {
                                width: "600px",
                                title: "Новая серия",
                            }
                        }], []),
                ]}
                modelActions={(item) => [
                    ...IfElse(
                        (create == true), [
                        {
                            title: "Изменить",
                            modal: {
                                width: "600px",
                                title: "Изменить серию",
                            },
                            object: item,
                            // options: {
                            //     initialValues: item,
                            // },
                            isFormData: true,
                            modify: (values) => {
                                return { ...item, ...values }
                            },
                            action: (values, unlock, close, { collection, setCollection }) => {
                                // let o = { ...item, ...values }
                                // POST(auth, `/api/serii/update`, o,
                                //     ({ data }) => {
                                //         setCollection(updateInArray(collection, data));
                                //         close();
                                //     }, errorCatch
                                // );
                                POSTFormData(auth, `/api/serii/update`, values,
                                    ({ data }) => {
                                        setCollection(updateInArray(collection, data));
                                        close();
                                    },
                                    (err) => errorCatch(err, unlock));
                            },
                            form: Model,
                            meta: [
                                {
                                    label: "Опубликовано",
                                    name: "isPublic",
                                    type: "bool",
                                },
                                {
                                    label: "Название",
                                    name: "nazvanie",
                                    type: "string",
                                },
                                {
                                    label: "Сезон",
                                    name: "sezon",
                                    type: "object",
                                    relation: {
                                        display: (item) => {
                                            return item.nazvanie
                                        },
                                        reference: { object: "Sezoni", property: "ID" },
                                        type: "many-one",
                                    },
                                    queryFilter: [
                                        QueryDetail("model"),
                                        QueryOrder("prioritet", "ASC")
                                    ]
                                },
                                {
                                    label: "Уровень серии",
                                    name: "urovenSerii",
                                    type: "object",
                                    relation: {
                                        display: (item) => {
                                            return item.opisanie
                                        },
                                        reference: { object: "UrovenSerii", property: "ID" },
                                        type: "many-one",
                                    },
                                    queryFilter: [
                                        QueryParam("w-eqi-UrovenSeriiVidOrgUroven.Organizator.Code", sourceKey),
                                        QueryDetail("model"),
                                        QueryOrder("ID", "ASC")
                                    ]
                                },
                                {
                                    label: "Количество этапов",
                                    name: "kolichestvoEtapov",
                                    type: "int",
                                },
                                {
                                    label: "Ссылка на серию в ВК",
                                    name: "vk",
                                    type: "string",
                                },
                                {
                                    label: "Описание",
                                    name: "opisanie",
                                    type: "text",
                                },
                                {
                                    label: "Описание для ВК",
                                    name: "opisanieDlyaVK",
                                    type: "text",
                                },
                                {
                                    label: "Афиша",
                                    name: "file",
                                    type: "file",
                                },
                                {
                                    hidden: true,
                                    label: "Афиша",
                                    name: "afisha",
                                    type: "string",
                                },
                                {
                                    hidden: true,
                                    label: "Афиша",
                                    name: "afishaMin",
                                    type: "string",
                                },
                            ],
                        }], []),
                    ...IfElse(
                        (create == true), [{
                            auth: auth,
                            title: <span style={{ color: "red" }}>Удалить</span>,
                            action: (values, unlock, close, { collection, setCollection }) => {
                                confirmKey({
                                    pass: '123',
                                    title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить серию</span>,
                                    icon: undefined,
                                    content: <span>Вы действительно хотите удалить серию?</span>,
                                    okText: 'Удалить',
                                    cancelText: 'Отмена',
                                    onOk() {
                                        return new Promise((resolve, reject) => {
                                            GET(auth, '/api/serii/delete/' + item.ID,
                                                ({ data }) => {
                                                    setCollection(deleteInArray(collection, item));
                                                    resolve(data);
                                                }, (err) => errorCatch(err, reject));
                                        }).catch(() => { });
                                    },
                                    onCancel() {
                                    },
                                })

                            }
                        }], []),
                    {
                        create: create,
                        readonly: true,
                        noAntForm: true,
                        title: "Направления танцев",
                        modal: {
                            width: "600px",
                            bodyStyle: { padding: "12px" }
                        },
                        object: item,
                        action: (values, unlock, close, { collection, setCollection }) => { },
                        form: TantsiSerii // /api/serii/tantsi/{seriyaID}
                    },
                    {
                        create: create,
                        readonly: true,
                        noAntForm: true,
                        title: "Мероприятия",
                        modal: {
                            width: "600px",
                            bodyStyle: { padding: "12px" }
                        },
                        object: item,
                        action: (values, unlock, close, { collection, setCollection }) => { },
                        form: SeriiMeropriyatiya // /api/serii/meropriyatiya/{seriyaID}
                    },
                    {
                        create: create,
                        readonly: true,
                        noAntForm: true,
                        title: "Города серий",
                        modal: {
                            width: "600px",
                            bodyStyle: { padding: "12px" }
                        },
                        object: item,
                        action: (values, unlock, close, { collection, setCollection }) => { },
                        form: GorodaSerii
                    },
                    {
                        create: create,
                        readonly: true,
                        object: item,
                        action: (values, unlock, close) => {
                            if (close) close();
                        },
                        // sourceKey: sourceKey,
                        title: "Категории участников",
                        modal: {
                            width: (create) ? "1000px" : "600px",
                        },
                        form: KategoriiUchastnikovSerii
                    },
                    {
                        create: create,
                        readonly: true,
                        noAntForm: true,
                        title: "Квоты",
                        modal: {
                            width: "600px",
                            bodyStyle: { padding: "12px" },
                            title: <div>
                                <div>Квоты</div>
                                <div style={{ fontSize: "14px" }}>{item?.nazvanie} {(item?.sezon?.nazvanie) ? "(" + item?.sezon?.nazvanie + ")" : ""}</div>
                            </div>
                        },
                        object: item,
                        action: (values, unlock, close, { collection, setCollection }) => { },
                        form: Kvoti
                    },
                    ...IfElse(
                        (create == true), [{
                            create: create,
                            readonly: true,
                            object: item,
                            action: (values, unlock, close) => {
                                if (close) close();
                            },
                            // sourceKey: sourceKey,
                            title: "Вышестоящие мероприятия",
                            form: ParentEventSerii,
                            modal: {
                                width: "600px"
                            }
                        },
                        {
                            title: "Грамоты",
                            object: item,
                            auth: auth,
                            form: SeriiDiplomas,
                            isFormData: true,
                            action: (values, unlock, close) => {
                                auth.fetchRaw(`/api/serii/diplomas/${item.ID}`, {
                                    method: 'POST',
                                    body: values
                                }).then(async (res) => {
                                    if (res.headers.get("Content-Type") == "application/json") {
                                        let jData = await res.json();
                                        if (jData && !jData.status) {
                                            message.error(jData.message);
                                        }
                                        unlock();
                                    } else {
                                        res.blob().then(blob => {
                                            let url = window.URL.createObjectURL(blob);
                                            let a = document.createElement('a');
                                            a.href = url;
                                            //replace(/^\"+|\"+$/g, '') - trim('"')
                                            let fname = res.headers.get("x-filename") || "";
                                            a.download = decodeURI(fname.replace(/^\"+|\"+$/g, ''));
                                            a.click();
                                        });
                                        close()
                                    }
                                }).catch(() => {
                                    message.error('Ошибка загрузки.');
                                    unlock();
                                })
                            }
                        },
                        {
                            auth: auth,
                            title: <span>Результаты</span>,
                            action: (values, unlock, close, { collection, setCollection }) => {
                                auth.fetchFile(`/api/rezultati-serii/${item.ID}`)
                                // .then(async (res) => {

                                // });
                            }
                        },
                        {
                            title: "Промежуточные результаты для VK",
                            mode: "MenuItem",
                            object: item,
                            auth: auth,
                            form: PromResultSeriiVK,
                            readonly: true,
                            noAntForm: true,
                            modal: {
                                width: "660px"
                            },
                            action: (values, unlock, close) => {
                            }
                        },
                        {
                            title: "Итоговые результаты для VK",
                            mode: "MenuItem",
                            object: item,
                            auth: auth,
                            form: ItogResultSeriiVK,
                            readonly: true,
                            noAntForm: true,
                            modal: {
                                width: "660px"
                            },
                            action: (values, unlock, close) => {
                            }
                        }
                    ], []),
                ]}
            />}
        </div>
    );
}
